/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'windmill': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M24 5.375c5.801 0 10.625 4.239 10.625 9.625 0 3.628-2.19 6.733-5.392 8.375H42c.345 0 .625.28.625.625 0 5.801-4.239 10.625-9.625 10.625-3.628 0-6.733-2.19-8.375-5.392V42c0 .345-.28.625-.625.625-5.801 0-10.625-4.239-10.625-9.625 0-3.628 2.19-6.733 5.392-8.375H6A.625.625 0 015.375 24c0-5.801 4.239-10.625 9.625-10.625 3.628 0 6.733 2.19 8.375 5.39V6c0-.345.28-.625.625-.625zm-.625 19.27c-4.94.288-8.75 3.965-8.75 8.355 0 4.39 3.81 8.066 8.75 8.355v-16.71zm1.27-.02c.289 4.94 3.965 8.75 8.355 8.75 4.39 0 8.066-3.81 8.355-8.75h-16.71zm-9.645-10c-4.39 0-8.066 3.81-8.354 8.75h16.709c-.289-4.94-3.965-8.75-8.355-8.75zm9.625 8.73c4.94-.289 8.75-3.965 8.75-8.355 0-4.39-3.81-8.067-8.75-8.355v16.71z" _fill="#0077C8"/>'
  }
})
